import React from 'react'
import styles from './AiIndustrySolutions.module.css'

type IconComponent = React.ComponentType<{ className?: string }>

export type AiIndustrySolutionItem = {
  id?: string
  title: string
  description: string
  Icon: IconComponent
}

/** Page-level data object passed as `data` (same pattern as `ProvenChannelSection`). */
export type AiIndustrySolutionsData = {
  heading: string
  subheading: string
  items: AiIndustrySolutionItem[]
}

export type AiIndustrySolutionsProps = {
  data: AiIndustrySolutionsData
}

function IndustryCard({ item }: { item: AiIndustrySolutionItem }) {
  const { title, description, Icon } = item

  return (
    <div className="col-12 col-md-6 col-lg-3 d-flex">
      <div className={`${styles.card} w-100 h-100`}>
        <div className={styles.iconBox}>
          <Icon className={styles.icon} />
        </div>

        <div className={styles.cardBody}>
          <h3 className={styles.cardTitle}>{title}</h3>
          <p className={styles.cardDesc}>{description}</p>
        </div>
      </div>
    </div>
  )
}

export default function AiIndustrySolutions({
  data,
}: AiIndustrySolutionsProps) {
  const { heading, subheading, items } = data

  return (
    <section className={styles.section}>
      <div className="container">
        <div className={styles.header}>
          <h2 className={styles.heading}>{heading}</h2>
          <p className={styles.subheading}>{subheading}</p>
        </div>

        <div className="row g-3">
          {items.map((item) => (
            <IndustryCard key={item.id ?? item.title} item={item} />
          ))}
        </div>
      </div>
    </section>
  )
}
